import { KeyboardEvent } from 'react';
import TextField from 'components/TextField';
import './index.scss';
import { useState } from 'react';
import { SearchIcon } from 'components/icons/SearchIcon';

interface SearchProps {
  query?: string;
  disabled?: boolean;
  onSearch?: () => void;
  onSearchTerms?: (value: string) => void;
  placeholder: string;
  lightMode?: boolean;
}

export const Search = ({
  query = '',
  onSearch,
  onSearchTerms,
  disabled = false,
  placeholder,
  lightMode
}: SearchProps) => {
  const [openSearchResults, setOpenSearchResults] = useState(false);

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onSearch) {
      onSearch();
      setOpenSearchResults(false);
    }
  };

  const handleOnChange = (value: string) => {
    setOpenSearchResults(true);
    onSearchTerms && onSearchTerms(value);
  };

  return (
    <div className="relative inline-block w-full">
      <TextField
        size="medium"
        icon={<SearchIcon className="absolute left-2 w-[15px] h-[15px]" fill="currentColor" />}
        disabled={disabled}
        fullWidth={true}
        type="search"
        name="search"
        value={query}
        placeholder={placeholder}
        onKeydown={handleKeyDown}
        onChange={handleOnChange}
        additionalClasses="h-[26px] pr-10 sm:pr-32"
        lightMode={lightMode}
      />
      {/* {openSearchResults && (
        <div
          className="origin-top-left z-30 absolute w-full left-0 mt-2 rounded-2xl shadow-lg bg-gray-main ring-1 ring-black ring-opacity-5 overflow-hidden focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex={-1}
          style={{ display: query ? 'block' : 'none' }}
        >
          <div
            className="group flex items-center justify-between px-7 py-1 text-sm"
            role="menuitem"
            tabIndex={-1}
            id="menu-item-0"
          >
            <span className="font-lato text-white text-lg font-normal">
              Search for: <b>{query}</b>
            </span>
            <span className="font-lato text-white text-sm font-normal">
              Press: <b>ENTER</b>
            </span>
          </div>
        </div>
      )} */}
    </div>
  );
};
